import loginMainUnifiedSelector from './login_main_unified_selector'
import loginLmsSelector from './login_lms_selector'
import loginSsoErrorSelector from './login_sso_error_selector'

export default {
	loginMainUnifiedSelector,
	loginLmsSelector,
	loginSsoErrorSelector,
}
